import * as React from 'react';
import cn from 'classnames';
import { responsiveClasses } from '../../../../library';
import { fieldClasses } from '../../field';
export var Control = function Control(props) {
  var align = props.align,
    offset = props.offset,
    order = props.order,
    span = props.span;
  var className = cn(fieldClasses.CONTROL, align ? responsiveClasses('-%s', align) : null, offset ? responsiveClasses('-offset-%s', offset) : null, order ? responsiveClasses('-order-%s', order) : null, span ? responsiveClasses('-span-%s', span) : null, props.className);
  return React.createElement("div", {
    className: className
  }, props.children);
};
export var Controls = function Controls(props) {
  var className = cn(fieldClasses.CONTROLS, {
    '-combined': props.isCombined
  }, props.className);
  return React.createElement("div", {
    className: className
  }, props.children);
};